import styled, { css, keyframes } from 'styled-components';

export const SelectDisplay = styled.select`
  display: block;
  flex: 1;
  padding: 0.6em 1em;
  font-size: 1em;
  line-height: 1.2em;
  color: #495057;
  background-color: #fff;
  background-clip: padding-box;
  border: none;
  border-radius: 0.25rem;
  box-shadow: 0px 0px 0px 1px  #c7d7e1;

  ${(props) => (props.error && `
    box-shadow: 0px 0px 0px 1px ${props.theme.dangerColor};
  `)};

  font-family: ${(props) => props.theme.primaryFont};
  -webkit-appearance: none;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;

  &:focus {
    box-shadow: 0px 0px 2px 1px ${(props) => props.theme.brandColor};
  }

  ::placeholder {
    font-weight: 300;
    color: rgb(158, 171, 180);
  }
`;

export const Required = styled.span`
  font-weight: 400;
  font-size: 1.2em;
  position: relative;
  left: 2px;
  color: #F44336;
`;

export const FloatingLabel = styled.div`
  top: 14px;
  left: 8px;
  font-size: 12px;
  visibility: hidden;
  position: absolute;
  color: ${(props) => props.theme.primaryColor};
  transition: top 0.1s ease-out;
  font-family: ${(props) => props.theme.primaryFont};

  ${({ error }) =>
    error &&
    css`
      color: ${(props) => props.theme.warningColor};
    `};

  ${({ show }) =>
    show &&
    css`
      top: 8px;
      visibility: unset;
    `};
`;

export const Flex = styled.div`
  flex: 1;
  display: flex;
  position: relative;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const Underline = styled.div`
  width: 0px;
  height: 0px;
  display: flex;
  position: relative;
  transition: width 0.2s ease-out;
  background-color: ${(props) => props.theme.primaryColor};

  ${({ show }) =>
    show &&
    css`
      height: 2px;
      width: 100%;
    `};

  ${({ hasValue }) =>
    hasValue &&
    css`
      height: 1px;
      width: 100%;
      background-color: ${(props) => props.theme.disabled};
    `};

  ${({ error }) =>
    error &&
    css`
      background-color: ${(props) => props.theme.warningColor};
    `};
`;

export const SelectContain = styled.div`
  position: relative;
  display: flex;
  border-radius: 4;

  fontWeight: ${(props) => (props.bold ? 400 : 300)}
  padding: 1px;
  flex: 1;
  width: 100%;
  display: flex;
  border-radius: 2px;
`;

export const SelectContainer = styled.div`
  flex: 1;
  margin-bottom: 12px;
`;

export const PlaceHolderText = styled.div`
  left: 16px;
  top: 12px;
  bottom: 6px;
  font-size: 16px;
  position: relative;
  font-weight: 300;
  position: absolute;
  font-family: ${(props) => props.theme.primaryFont};

  font-weight: 300;
  color: rgb(158, 171, 180);
`;

const zoomIn = keyframes`
  0% {
    transform: translateX(-20px); 
  }
  60% {
    transform: translateX(10px); 
  }
  100% {
    transform: translateX(0px); 
  }
`;

export const ErrorInnerContain = styled.div`
  padding: 4px;
  position: relative;

  background-color: #ffffff;

  animation-duration: 0.3s;
  animation-name: ${zoomIn};
  animation-fill-mode: forwards;
  animation-timing-function: ease-in-out;

  display: flex;
  justify-content: flex-start;
`;

export const ErrorContain = styled.div`
  z-index: 9999;
  margin-top: 8px;
}
`;
export const ArrowContain = styled.div``;

export const ArrowShadow = styled.div`
  width: 0;
  height: 0;
  border-left: 12px solid transparent;
  border-right: 12px solid #a24e4e00;
  border-bottom: 12px solid #dcdcdc57;
  position: absolute;
  bottom: 100%;
  right: calc(50% - 7px);
`;

export const Arrow = styled.div`
  width: 0;
  height: 0;
  z-index: 9999;
  border-left: 10px solid transparent;
  border-right: 10px solid #a24e4e00;
  border-bottom: 10px solid white;

  position: absolute;
  bottom: 100%;
  right: calc(50% - 5px);
`;

export const FlexRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: row;
`;

export const MarginRight = styled.div`
  margin-right: 8px;
`;

export const Label = styled.div`
  font-size: 16px;

  font-size: 0.9em;
  font-weight: 400;
  margin-bottom: 4px;

  color: rgb(1, 52, 83);
  transition: top 0.1s ease-out;
  font-family: ${(props) => props.theme.primaryFont};

  ${({ error }) =>
    error &&
    css`
      color: ${(props) => props.theme.dangerColor};
    `};
`;
